import * as React from "react";
import SimpleSelect, {SimpleSelectItem} from "components/form/Select/SimpleSelect";
import {BetterUptimeStatus} from "client/resources/betterUptimeStatus";

interface BetterUptimeStatusSelectProps {
    value: string | undefined;
    onChange(newValue: string): void;
}

const items: SimpleSelectItem[] = [
    {value: "", text: ""},
    {value: BetterUptimeStatus.Down, text: BetterUptimeStatus.Down},
    {value: BetterUptimeStatus.Unknown, text: BetterUptimeStatus.Unknown},
    {value: BetterUptimeStatus.Maintenance, text: BetterUptimeStatus.Maintenance},
    {value: BetterUptimeStatus.Validating, text: BetterUptimeStatus.Validating},
    {value: BetterUptimeStatus.Pending, text: BetterUptimeStatus.Pending},
    {value: BetterUptimeStatus.Paused, text: BetterUptimeStatus.Paused},
    {value: BetterUptimeStatus.Up, text: BetterUptimeStatus.Up},
];

const BetterUptimeStatusSelect: React.FC<BetterUptimeStatusSelectProps> = props => (
    <SimpleSelect
        label="Better Uptime Status"
        value={props.value}
        onChange={props.onChange}
        items={items}
    />
);

export default BetterUptimeStatusSelect;
